import css from 'styled-jsx/css';
import { warmGrays } from 'styles/colors/constants';
import { MQ_LARGE, MQ_MIDLARGE } from 'constants/mq';

export default css`
  .Spread__description,
  .Spread__title {
    margin-right: 0;
    margin-left: 0;
  }

  .Spread__item {
    margin-bottom: 1.125rem;
  }

  .Spread__items {
    display: flex;
    flex-direction: column;
  }

  .Spread__title {
    margin: 0 0 1rem;
    border-bottom: none;
    padding: 0;
  }

  .Spread__title h4 {
    color: ${warmGrays[7]};
    text-transform: none;
  }

  @media ${MQ_LARGE} {
    .Spread__items {
      width: 100%;
    }

    .Spread__title h4 {
      font-size: var(--baseFontSize);
    }
  }

  @media ${MQ_MIDLARGE} {
    .Spread__items {
      width: 100%;
    }
  }

  @supports (display: grid) {
    @media ${MQ_LARGE} {
      .Spread--navTextLink {
        grid-template:
          'title'
          'description'
          'items'
          / 100%;
      }

      .Spread__title,
      .Spread__description,
      .Spread__link {
        margin-right: 0;
        margin-left: 0;
      }
    }
  }
`;
